import {Box, Button, Typography} from "@mui/material";
import {useState} from "react";
import {Link} from "react-router-dom";
import * as React from "react";

export const InscriptionChoice = () => {
    const [selected, setSelected] = useState("particulier");

    const handleSelect = (choice) => {
        setSelected(choice);
    };

    return (
        <>
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                className="my-5"
            >
                {/* Top Button */}
                <Button
                    component="a"
                    variant={selected === "particulier" ? "contained" : "outlined"}
                    href="/inscription/particulier"
                    sx={{
                        width: "200px",
                        marginBottom: "10px",
                    }}

                    className="justify-content-center"
                >
                    <span className="flex-column justify-content-center">
                        Particulier
                    </span>
                </Button>

                {/* "Ou" Text */}
                <Typography variant="h6" sx={{marginBottom: "10px"}}>
                    ou
                </Typography>

                {/* Bottom Button */}
                <Button
                    component="a"
                    variant={selected === "professionnel" ? "contained" : "outlined"}
                    href="/inscription/agence-admin"
                    sx={{
                        width: "200px",
                    }}
                >
                    Professionnel
                </Button>
            </Box>
            <div className="d-flex w-full h- justify-content-center align-items-end mb-4">
                <Link as={Link} to="/">
                    Se connecter ?
                </Link>
            </div>
        </>
    )
}